<template>
  <div class="form-group">
    <label>
      <strong>Dias configurados para transferência:</strong>
    </label>
    <div class="input-group input-group-lg">
      <input
        class="form-control"
        type="text"
        v-model="days"
        :disabled="!enableEditInput"
        placeholder="Dias separados por vírgula"
      >
      <span class="input-group-btn">
        <button
          class="btn btn-primary"
          @click="enableEditDays()"
          title="Editar"
          type="button"
          v-if="!enableEditInput"
          v-permissions:transfer_day.create
        >
          Editar
        </button>
        <button
          class="btn btn-primary"
          @click="salveDays()"
          :disabled="somethingChanged()"
          title="Salvar "
          type="button"
          v-if="enableEditInput"
          v-permissions:transfer_day.create
        >
          Salvar
        </button>
        <button
          class="btn btn-danger"
          @click="cancelEditDays()"
          title="Cancelar"
          type="button"
          v-if="enableEditInput"
          v-permissions:transfer_day.create
        >
          Cancelar
        </button>
      </span>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import TransferDaysService from 'services/TransferDaysService';
import Permissions from 'mixins/Permissions';
import _ from 'lodash';

export default {
  mixins: [Permissions],

  computed: {
    ...mapState([
      'institution',
      'transferDays',
    ]),
  },

  data() {
    return {
      enableEditInput: false,
      days: [],
    };
  },

  mounted() {
    this.days = this.transferDays.days;
  },

  methods: {
    ...mapMutations([
      'setTransferDays',
    ]),

    cancelEditDays() {
      this.enableEditInput = false;
      this.days = this.transferDays.days;
    },

    enableEditDays() {
      this.enableEditInput = true;
    },

    parseDays() {
      return this.days.replace(/\s+/g, '').split(',');
    },

    salveDays() {
      this.$loader.show();

      TransferDaysService.create(this.institution.id, this.parseDays())
        .then((data) => {
          this.setTransferDays(data);
          this.$alert.notifySuccess('Dias de transferência atualizados com sucesso.');
        })
        .catch(({ response: { data } }) => {
          this.days = this.transferDays.days;
          this.$alert.notifyAlert(data.message);
        })
        .finally(() => {
          this.enableEditInput = false;
          this.$loader.hide();
        });
    },

    somethingChanged() {
      return _.isEqual(this.transferDays.days, this.days);
    },
  },
};
</script>
